<template>
    <v-skeleton-loader
      :loading="loading"
      type="list-item"
      transition="scale-transition"
      width="20%"
    >
      <v-text-field
        solo
        flat
        dense
        persistent-hint
        :hint="label"
        :value="value"
        readonly
      ></v-text-field>
    </v-skeleton-loader>

</template>

<script>
export default {
  name: 'read-only-field',
  props: {
    label: {
      required: true,
      type: String
    },
    value: {
      required: true
    },
    loading: {
      required: false,
      default: false
    }
  },
  data: function () {
    return {
    }
  }
}
</script>
